import { SxProps } from '@mui/material'

import theme from '../../../../../../shared/styles/themes/default.theme'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    width: '100%'
  } as SxProps,

  pickupCodeSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    padding: theme.spacing(2.5, 0)
  } as SxProps,

  pickupCodeLabel: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    color: theme.palette.grey[400],
    letterSpacing: '1.5px',
    textTransform: 'uppercase'
  } as SxProps,

  pickupCodeBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    padding: theme.spacing(2.5, 3),
    borderRadius: theme.spacing(1.25),
    background: 'linear-gradient(135deg, #F5F3FF 0%, #EDE9FE 100%)',
    border: '1px solid #DDD6FE',
    cursor: 'pointer',
    transition: 'opacity 0.2s ease',
    '&:hover': {
      opacity: 0.85
    }
  } as SxProps,

  pickupCodeText: {
    fontSize: '2rem',
    fontWeight: 700,
    color: theme.palette.primary.main,
    letterSpacing: '3px',
    fontFamily: 'DM Sans, sans-serif'
  } as SxProps,

  copyIcon: {
    color: theme.palette.primary.light,
    fontSize: 20
  } as SxProps,

  pickupCodeHintText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[400]
  } as SxProps,

  sectionDivider: {
    margin: theme.spacing(0),
    borderColor: '#E5E7EB'
  } as SxProps,

  sectionHeaderContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    width: '100%',
    marginBottom: theme.spacing(2)
  } as SxProps,

  sectionIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: theme.spacing(1),
    backgroundColor: '#F5F3FF',
    flexShrink: 0
  } as SxProps,

  sectionIcon: {
    color: theme.palette.primary.main,
    fontSize: 18
  } as SxProps,

  sectionTitleText: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps,

  locationCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    overflow: 'hidden'
  } as SxProps,

  locationRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    padding: theme.spacing(1.5, 2)
  } as SxProps,

  locationRowIcon: {
    color: theme.palette.grey[400],
    fontSize: 16,
    flexShrink: 0
  } as SxProps,

  locationRowLabelText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[400],
    width: 65,
    flexShrink: 0
  } as SxProps,

  locationRowValueText: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: theme.palette.grey[800],
    lineHeight: 1.5
  } as SxProps,

  locationRowDivider: {
    margin: 0,
    borderColor: '#E5E7EB'
  } as SxProps,

  openingTimesHeaderIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: theme.spacing(1),
    backgroundColor: '#FEF3C7',
    flexShrink: 0
  } as SxProps,

  openingTimesHeaderIcon: {
    color: '#D97706',
    fontSize: 18
  } as SxProps,

  collapsibleCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    overflow: 'hidden'
  } as SxProps,

  collapseHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.75, 2),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F3F4F6'
    }
  } as SxProps,

  collapseHeaderLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25)
  } as SxProps,

  collapseHeaderDayText: {
    fontSize: '0.8125rem',
    fontWeight: 600,
    color: theme.palette.grey[800]
  } as SxProps,

  collapseHeaderSubtitleText: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    color: theme.palette.primary.main
  } as SxProps,

  collapseHeaderRight: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  } as SxProps,

  collapseHeaderTimeText: {
    fontSize: '0.8125rem',
    fontWeight: 500,
    color: theme.palette.grey[700]
  } as SxProps,

  chevronIcon: {
    color: theme.palette.grey[400],
    fontSize: 16,
    transition: 'transform 0.2s ease'
  } as SxProps,

  chevronIconExpanded: {
    color: theme.palette.grey[400],
    fontSize: 16,
    transform: 'rotate(180deg)',
    transition: 'transform 0.2s ease'
  } as SxProps,

  expandedBody: {
    padding: theme.spacing(1, 2, 1.5, 2)
  } as SxProps,

  expandedBodyDivider: {
    margin: 0,
    borderColor: '#E5E7EB'
  } as SxProps,

  dayRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0)
  } as SxProps,

  dayNameText: {
    fontSize: '0.75rem',
    color: theme.palette.grey[500]
  } as SxProps,

  dayTimeText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.grey[700]
  } as SxProps,

  flightDayNameText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.primary.main
  } as SxProps,

  flightDayTimeText: {
    fontSize: '0.75rem',
    fontWeight: 600,
    color: theme.palette.primary.main
  } as SxProps,

  closedTimeText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: '#EF4444'
  } as SxProps,

  sectionPadding: {
    padding: theme.spacing(2.5, 0)
  } as SxProps
}

export default styles
